import React from "react";
import { useCategory } from "@elevio/kb-kit/lib/hooks";
import * as Article from "@elevio/kb-kit/lib/components/article";
import * as Articles from "@elevio/kb-kit/lib/components/articles";
import { faqArticleIds } from "../utils/constants";
function ArticleList({ className, isRelated }) {
    const category = useCategory({ usePageCategory: false });
    return (<div className={className}>
      <h3 className={!isRelated ? 'home-article-title' : 'related-articles'}>
        {isRelated ? 'Related Articles' : category && category.title}
      </h3>
      <ul className="article-list">
        {isRelated ? (<Articles.Loop>
            <Article.IsNotActive>
              <Article.RenderFragment>
                <li className="article-list-item home-article-info">
                  <Article.Link className="article-list-link">
                    <Article.Title />
                  </Article.Link>
                </li>
              </Article.RenderFragment>
            </Article.IsNotActive>
          </Articles.Loop>) : (faqArticleIds.map(article => (<Article.IsNotActive key={article}>
              <Article.RenderFragment articleId={article}>
                <li className="article-list-item home-article-info">
                  <Article.Link articleId={article} className="article-list-link">
                    <Article.Title articleId={article}/>
                  </Article.Link>
                </li>
              </Article.RenderFragment>
            </Article.IsNotActive>)))}
      </ul>
    </div>);
}
export default ArticleList;
